import { render, staticRenderFns } from "./SettingsDashboard.vue?vue&type=template&id=c8d611e0&scoped=true"
import script from "./SettingsDashboard.vue?vue&type=script&lang=js"
export * from "./SettingsDashboard.vue?vue&type=script&lang=js"
import style0 from "./SettingsDashboard.vue?vue&type=style&index=0&id=c8d611e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d611e0",
  null
  
)

export default component.exports